export default from './Attachments';

export const getExtension = fileName => {
	const re = /(?:\.([^.]+))?$/;
	return re.exec(fileName)[1];
};

/*
const crypto = require('crypto');

export const hash = str => {
	return crypto.createHash('md5').update(str).digest("hex").substr(0, 10);
};
*/

export const acceptedTypes = [
	
	// images
	'image/jpeg', // .jpeg, .jpg - JPEG images
	'image/png', // .png - Portable Network Graphics
	'image/gif', // .gif - Graphics Interchange Format (GIF)
	'image/x-icon', // .ico - Icon format
	'image/svg+xml', // .svg - Scalable Vector Graphics (SVG)
	'image/tiff', // .tif, .tiff - Tagged Image File Format (TIFF)
	'image/webp', // .webp - WEBP image

	// archives
	'application/zip', // .zip - ZIP archive
	'application/x-7z-compressed', // .7z - 7-zip archive
	'application/x-bzip', // .bz - BZip archive
	'application/x-bzip2', // .bz2 - BZip2 archive
	'application/x-rar-compressed', // .rar - RAR archive
	'application/x-tar', // .tar - Tape Archive (TAR)

	// documents
	'application/msword', // .doc - Microsoft Word
	'application/vnd.ms-excel', // .xls - Microsoft Excel
	'application/vnd.visio', // .vsd - Microsoft Visio
	'application/vnd.ms-powerpoint', // .ppt - Microsoft PowerPoint
	'application/pdf', // .pdf - Adobe Portable Document Format (PDF)
	'application/rtf', // .rtf - Rich Text Format (RTF)
	'application/vnd.oasis.opendocument.presentation', // .odp - OpenDocument presentation document
	'application/vnd.oasis.opendocument.spreadsheet', // .ods - OpenDocument spreadsheet document
	'application/vnd.oasis.opendocument.text', // .odt - OpenDocument text document
	'application/x-abiword', // .abw - AbiWord document

	// audio
	'audio/aac', // .aac - AAC audio file
	'audio/3gpp', // .3gp - 3GPP audio container
	'audio/3gpp2', // .3g2 - 3GPP2 video container
	'audio/midi', // .mid, .midi - Musical Instrument Digital Interface (MIDI)
	'audio/ogg', // .oga - OGG audio
	'audio/webm', // .weba - WEBM audio
	'audio/x-wav', // .wav - Waveform Audio Format

	// video
	'video/3gpp2', // .3g2 - 3GPP2 video container
	'video/3gpp', // .3gp - 3GPP video container
	'video/mpeg', // .mpeg - MPEG Video
	'video/ogg', // .ogv - OGG video
	'video/webm', // .webm - WEBM video
	'video/x-msvideo', // .avi - AVI: Audio Video Interleave

	// fonts
	'font/ttf', // .ttf - TrueType Font
	'font/woff', // .woff - Web Open Font Format (WOFF)
	'font/woff2', // .woff2 - Web Open Font Format (WOFF)
	
	// misc
	'application/octet-stream', // Any kind of binary data
	'application/json', // .json - JSON format
	'application/xml', // .xml - XML
	'text/html', // .htm, .html - HyperText Markup Language (HTML)
	'text/css', // .css - Cascading Style Sheets (CSS)
	'text/csv', // .csv - Comma-separated values (CSV)
	// 'text/calendar', // .ics - iCalendar format
	// 'application/vnd.amazon.ebook', // .azw - Amazon Kindle eBook format
	// 'application/x-csh', // .csh - C-Shell script
	// 'application/epub+zip', // .epub - Electronic publication (EPUB)
	// 'application/java-archive', // .jar - Java Archive (JAR)
	// 'application/javascript', // .js - JavaScript (ECMAScript)
	// 'application/vnd.apple.installer+xml', // .mpkg - Apple Installer Package
	// 'application/ogg', // .ogx - OGG
	// 'application/x-sh', // .sh - Bourne shell script
	// 'application/x-shockwave-flash', // .swf - Small web format (SWF) or Adobe Flash document
	// 'application/xhtml+xml', // .xhtml - XHTML
	// 'application/vnd.mozilla.xul+xml', // .xul - XUL

];
